import {
    MindyKnowledgePermissions,
    MindyLogisticPermissions,
    MindyRolesPermissions,
    MindyUsersPermissions,
} from './permissions';

// Los permisos de los roles de mindy estan
// en funcion del incremento de permisos acumulados en groupedRoles.ts

export enum MindyStandardRoles {
    ADMIN = 'mindy:admin',
    MANAGER = 'mindy:manager',
    GUEST = 'mindy:guest',
    CONSULTANT = 'mindy:consultant',
    OPERATIONAL = 'mindy:operational',
}

export enum MindyDocRoles {
    ADMIN_DOC = 'mindy:admin-doc',
    MANAGER_DOC = 'mindy:manager-doc',
    CONSULTANT_DOC = 'mindy:consultant-doc',
}

export const mindyGestRole = [MindyKnowledgePermissions.AskKnowledge, MindyLogisticPermissions.AskLogistic];

export const mindyOperationalRole = [MindyLogisticPermissions.AskLogistic];

export const mindyManagerRole = [MindyKnowledgePermissions.ReadKnowledge, MindyKnowledgePermissions.CreateKnowledge];

export const mindyConsultantRole = [MindyKnowledgePermissions.ReadKnowledge];

export const mindyAdminRole = [
    MindyUsersPermissions.CreateUser,
    MindyUsersPermissions.ReadUser,
    MindyUsersPermissions.UpdateUser,
    MindyUsersPermissions.DeleteUser,
    MindyRolesPermissions.CreateRole,
    MindyRolesPermissions.ReadRole,
    MindyRolesPermissions.UpdateRole,
    MindyRolesPermissions.DeleteRole,
    MindyKnowledgePermissions.UpdateKnowledge,
    MindyKnowledgePermissions.DeleteKnowledge,
];
